// 定义中文语言包对象
export default {

}